// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"a5f48b3a","737":"82f5c839"}[chunkId] + ".chunk.css";
};